export const DEFAULT_ACTIVE_DATES_EDUCATION_EXCLUDED_CLASS_IDS = ["welcome1"];
export const ACTIVE_DATES_EMPTY_PRESENT_INTRO_VARIANTS = Object.freeze({
  REAL_TODAY: "real_today",
  DATE_NAVIGATION: "date_navigation",
});

export function hasClassStoredContentBoxes(classData = {}) {
  return Array.isArray(classData?.contentBoxesOrder) && classData.contentBoxesOrder.length > 0;
}

export function shouldEducateEmptyPresentForSelectedDate({
  useActiveDates = false,
  isShareView = false,
  contentBoxesReady = false,
  selectedDateKey = "",
  classId = "",
  classContentBoxesOrder = [],
  presentDayVisibleCount = 0,
  excludedClassIds = DEFAULT_ACTIVE_DATES_EDUCATION_EXCLUDED_CLASS_IDS,
} = {}) {
  if (!useActiveDates) return false;
  if (isShareView) return false;
  if (!contentBoxesReady) return false;
  if (!selectedDateKey) return false;
  if (!classId || excludedClassIds.includes(classId)) return false;
  if (!Array.isArray(classContentBoxesOrder) || classContentBoxesOrder.length === 0) return false;
  return presentDayVisibleCount === 0;
}

export function getActiveDatesEmptyPresentIntroVariant({
  selectedDateKey = "",
  realTodayKey = "",
} = {}) {
  if (selectedDateKey && realTodayKey && selectedDateKey !== realTodayKey) {
    return ACTIVE_DATES_EMPTY_PRESENT_INTRO_VARIANTS.DATE_NAVIGATION;
  }

  return ACTIVE_DATES_EMPTY_PRESENT_INTRO_VARIANTS.REAL_TODAY;
}

export const shouldEducateEmptyPresentToday = shouldEducateEmptyPresentForSelectedDate;
